import React from 'react'

function PageNotFound() {
  return (
    <div className='pnfContainer'>
        
    </div>
  )
}

export default PageNotFound